import {isEmpty} from 'lodash';

import {
    PL_LIST, PI_CHART, DEFAULT_AGENCY_PROFILE, REVENUE_GOAL, LINE_GRAPH,
    REVENUE_PROFILE, AGENCY_REVENUE, OVERRIDE_REVENUE_GOAL, LOG_OUT
} from './ActionTypes';
import AgencyRevenueService from './../services/AgencyRevenueService';
import {getUser} from "../utils/TokenManager";

const plListData = (plList) => ({type: PL_LIST, plList});

const piChartData = (piChart) => ({type: PI_CHART, piChart});

const defaultAgencyProfileData = (profileId, profile) => ({
    type: DEFAULT_AGENCY_PROFILE, profileId, profile
});

const getRevenueDate = (revenue) => ({type: AGENCY_REVENUE, revenue});

const getRevenueProfile = (revenueProfile) => ({type: REVENUE_PROFILE, revenueProfile});

const setRevenueGoal = (revenueGoal) => ({type: "REVENUE_GOAL", revenueGoal});

const setOverrideRevenueGoal = (overrideRevenueGoal) => ({
    type: OVERRIDE_REVENUE_GOAL, overrideRevenueGoal
});

const logOutSuccess = () => ({type: LOG_OUT});

const plLineGraph = (lineGraph) => ({type:LINE_GRAPH, lineGraph});

export const getInitialData = (locationId, defaultAgencyProfileId) => (
    async (dispatch) => {
        try {
            const plList = await AgencyRevenueService.plList(locationId);

            if (getUser()['app-version'] !== plList.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === plList.status) {
                if (typeof plList.data.pl_profile !== "undefined" && plList.data.pl_profile.length) {
                    dispatch(plListData(plList.data.pl_profile));
                    let defaultProfileList = [];
                    if (plList.data.pl_profile.length === 1) {
                        defaultProfileList = plList.data.pl_profile.map(profile => ({...profile}));
                    } else {
                        defaultProfileList = plList.data.pl_profile.filter((list) => list.is_default === true);
                    }
                    // if agency profile id has default value set already 
                    // then check whether it is present in the current list or not
                    // if present then set it as efault profile otherwise set new one as default
                    let defaultAgencyProfile = {};
                    if (defaultAgencyProfileId) {
                        plList.data.pl_profile.map(profile => {
                            if (profile.id === parseInt(defaultAgencyProfileId)) {
                                defaultAgencyProfile = {...profile};
                            }
                        });
                    } 

                    if (typeof defaultProfileList !== "undefined" && defaultProfileList.length) {
                        if(!(isEmpty(defaultAgencyProfile))) {
                            dispatch(defaultAgencyProfileData(defaultAgencyProfileId, defaultAgencyProfile));
                        } else {
                            defaultAgencyProfileId = defaultProfileList[0].id;
                            dispatch(defaultAgencyProfileData(defaultAgencyProfileId, defaultProfileList[0]));
                        }

                        const piChart = await AgencyRevenueService.piChart(defaultAgencyProfileId);
                        if (200 === piChart.status) {
                            dispatch(piChartData(piChart.data.pl_profile));
                            return true;
                        }
                    } else {
                        dispatch(piChartData({}));
                        dispatch(defaultAgencyProfileData(defaultAgencyProfileId, defaultAgencyProfile));
                        return true;
                    }
                } else {
                    dispatch(plListData(plList.data.pl_profile));
                    dispatch(piChartData({}));
                    dispatch(defaultAgencyProfileData("", {}));
                    return true;
                }
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("131-", error);
            throw error.response;
        }
        return false;
    }
);

export const setDefaultAgencyProfile = (profileId, selectedAgencyProfile) => (
    async (dispatch) => {
        try {
            dispatch(defaultAgencyProfileData(profileId, selectedAgencyProfile));
        } catch (error) {
            console.log("set default agency profile - ", error);
        }
    }
);

export const getPLProfile = (locationId) => (
    async (dispatch) => {
        try {
            const plList = await AgencyRevenueService.plList(locationId);

            if (getUser()['app-version'] !== plList.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === plList.status) {
                dispatch(plListData(plList.data.pl_profile));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("130-", error);
            throw error.response;
        }

        return false;
    }
);

export const getLineGraph = (plId) => (
    async (dispatch) => {
        try {
            const plList = await AgencyRevenueService.lineGraph(plId);

            if (getUser()['app-version'] !== plList.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === plList.status) {
                if (plList.data.pl_profile) {
                    dispatch(plLineGraph(plList.data.pl_profile));
                }
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("129-", error);
            throw error.response;
        }

        return false;
    }
);

export const getRevenuePlProfile = (plListProfile) => (
    async (dispatch) => {
        try {
            const revenueProfile = await AgencyRevenueService.getRevenuePlProfile(plListProfile);

            if (getUser()['app-version'] !== revenueProfile.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === revenueProfile.status) {
                dispatch(getRevenueProfile(revenueProfile.data.pl_profile));
                dispatch(getRevenueDate(revenueProfile.data.pl_profile.revenues));

                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("128-", error);
            throw error.response;
        }

        return false;
    }
);

export const saveRevenuePlProfile = (plListProfile, plProfile) => (
    async (dispatch) => {
        try {
            const revenueProfile = await AgencyRevenueService.saveRevenuePlProfile(plListProfile, plProfile);

            if (getUser()['app-version'] !== revenueProfile.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === revenueProfile.status || 201 === revenueProfile.status) {
                dispatch(getRevenueProfile(revenueProfile.data.pl_profile));
                dispatch(getRevenueDate(revenueProfile.data.pl_profile.revenues));

                return true;
            } else if (401 === revenueProfile.status) {
                dispatch(logOutSuccess());
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("127-", error);
            throw error.response;
        }

        return false;
    }
);

export const getRevenue = (plId) => (
    async (dispatch) => {
        try {
            const revenue = await AgencyRevenueService.getRevenue(plId);

            if (getUser()['app-version'] !== revenue.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === revenue.status) {
                dispatch(getRevenueDate(revenue.data.revenues));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("126-", error);
            throw error.response;
        }

        return false;
    }
);

export const saveRevenue = (revenues, plId) => (
    async (dispatch) => {
        try {
            const revenue = await AgencyRevenueService.saveRevenue(revenues, plId);

            if (getUser()['app-version'] !== revenue.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === revenue.status) {
                dispatch(getRevenueDate(revenue.data.revenues));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("125-", error);
            throw error.response;
        }

        return false;
    }
);

export const getRevenueGoal = (plId) => (
    async (dispatch) => {
        try {
            const revenue = await AgencyRevenueService.getRevenueGoal(plId);

            if (getUser()['app-version'] !== revenue.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === revenue.status) {
                dispatch(setRevenueGoal(revenue.data.pl_profile));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("124-", error);
            throw error.response;
        }

        return false;
    }
);

export const saveRevenueGoal = (revenue, plId) => (
    async (dispatch) => {
        try {
            const result = await AgencyRevenueService.saveRevenueGoal(revenue, plId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(setRevenueGoal(revenue));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("123-", error);
            throw error.response;
        }

        return false;
    }
);

export const getOverrideRevenueGoal = (plId) => (
    async (dispatch) => {
        try {
            const revenue = await AgencyRevenueService.getOverrideRevenueGoal(plId);

            if (getUser()['app-version'] !== revenue.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === revenue.status) {
                dispatch(setOverrideRevenueGoal(revenue.data.pl_profile));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("getOverrideRevenueGoal-", error);
            throw error.response;
        }
        return false;
    }
);

export const saveOverrideRevenueGoal = (revenue, plId) => (
    async (dispatch) => {
        try {
            const result = await AgencyRevenueService.saveOverrideRevenueGoal(revenue, plId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(setOverrideRevenueGoal(result.data.pl_profile));

                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            console.log("saveOverrideRevenueGoal-", error);
            throw error.response;
        }
        return false;
    }
);


// WEBPACK FOOTER //
// ./src/actions/AgencyRevenueAction.js